package com.example.readingnotes.presentation.postlist

sealed interface PostListEvent {
    data object OnAppear : PostListEvent

    data object OnRefresh : PostListEvent

    data object OnLoadMore : PostListEvent

    data object OnRetry : PostListEvent

    // Search events
    data class OnSearchQueryChanged(
        val query: String,
    ) : PostListEvent

    data object OnSearchSubmit : PostListEvent

    data object OnClearSearch : PostListEvent

    data object OnShowSuggestions : PostListEvent

    data object OnHideSuggestions : PostListEvent

    data class OnSuggestionsLoaded(
        val suggestions: List<String>,
    ) : PostListEvent

    // Sort events
    data class OnSortChanged(
        val sortBy: SortOption,
    ) : PostListEvent

    // Filter events
    data class OnStatusFilterChanged(
        val status: String?,
    ) : PostListEvent

    // Tag filter events
    data class OnTagFilterToggled(
        val tag: String,
    ) : PostListEvent

    data object OnClearTagFilters : PostListEvent

    data class OnPopularTagsLoaded(
        val tags: List<com.example.readingnotes.domain.model.TagWithCount>,
    ) : PostListEvent

    // Search history events
    data class OnSearchHistoryLoaded(
        val history: List<String>,
    ) : PostListEvent

    data object OnClearSearchHistory : PostListEvent

    // Settings events
    data class OnPageSizeChanged(
        val pageSize: Int,
    ) : PostListEvent

    data class OnAutoSearchToggled(
        val enabled: Boolean,
    ) : PostListEvent

    // Favorite search events
    data object OnShowFavoriteDialog : PostListEvent

    data object OnHideFavoriteDialog : PostListEvent

    data class OnFavoriteNameInputChanged(
        val name: String,
    ) : PostListEvent

    data object OnSaveFavoriteSearch : PostListEvent

    data class OnLoadFavoriteSearch(
        val favorite: com.example.readingnotes.platform.FavoriteSearch,
    ) : PostListEvent

    data class OnDeleteFavoriteSearch(
        val favoriteName: String,
    ) : PostListEvent

    data class OnFavoriteSearchesLoaded(
        val favorites: List<com.example.readingnotes.platform.FavoriteSearch>,
    ) : PostListEvent
}
